import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { PRODUCTS } from "@/data/site";

export default function ProductCard({ product }) {
  const { lang, t } = useLanguage();
  const p = product;
  return (
    <article
      data-testid={`product-card-${p.id}`}
      className="group flex h-full flex-col border hairline bg-velvet/50 transition-all duration-500 hover:border-gold/45 hover:shadow-[0_0_40px_rgba(212,175,55,0.12)]"
    >
      <Link
        to={`/product/${p.slug}`}
        data-testid={`product-card-image-${p.id}`}
        className="relative block aspect-[4/3] overflow-hidden"
        aria-label={p.name}
      >
        <img
          src={p.image}
          alt={p.name}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.06]"
        />
        <span className="absolute inset-0 bg-gradient-to-t from-obsidian/60 via-transparent to-transparent" />
        <span className="absolute right-4 top-4 border hairline bg-obsidian/70 px-3 py-1.5 text-[11px] font-medium uppercase tracking-widest text-gold backdrop-blur-sm">
          {p.currency}
          {p.price} · {p.size}
        </span>
      </Link>

      <div className="flex flex-1 flex-col p-6 md:p-7">
        <p className="text-[11px] font-medium uppercase tracking-luxe text-gold/90">
          {p.category[lang]}
        </p>
        <h3 className="mt-2.5 font-serif text-2xl text-cream">
          <Link to={`/product/${p.slug}`} className="transition-colors hover:text-gold-light">
            {p.name}
          </Link>
        </h3>
        <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-cream/60">
          {p.description[lang].split("\n")[0]}
        </p>
        <div className="mt-6 flex items-center justify-between border-t hairline pt-5">
          <span className="font-serif text-2xl text-gold">
            {p.currency}
            {p.price}
            <span className="ml-2 text-xs font-sans uppercase tracking-widest text-cream/50">
              {p.size}
            </span>
          </span>
          <Link
            to={`/product/${p.slug}`}
            data-testid={`product-view-details-${p.id}`}
            className="inline-flex items-center gap-2 text-[12px] font-medium uppercase tracking-[0.15em] text-gold transition-all duration-300 hover:gap-3.5"
          >
            {t.signature.viewDetails}
            <ArrowRight className="h-4 w-4" strokeWidth={1.5} />
          </Link>
        </div>
      </div>
    </article>
  );
}
